import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styles from "./Rbac.module.css";
import Loader from "../../../shared/Component/Loader";

export default function ViewRole() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [roleData, setRoleData] = useState({
    Role: "",
    Description: "",
    pageAccess: [],
  });

  // Sample static data — in real use, pull from location.state or API
  useEffect(() => {
    if (location.state?.role) {
      setRoleData(location.state.role);
    } else {
      // fallback demo data
      setRoleData({
        Role: "Supervisor",
        Description: "Can view and manage reports.",
        pageAccess: [
          { id: 1, name: "Dashboard", page: "dashboard", access: "Enable" },
          { id: 2, name: "Profile", page: "profile", access: "Disable" },
          { id: 3, name: "Reports", page: "reports", access: "Enable" },
          { id: 4, name: "Settings", page: "settings", access: "Disable" },
        ],
      });
    }
  }, [location.state]);

  const navigateBack = () => {
    navigate("/roleList");
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className="BathHeader global_container">
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">View Role</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={navigateBack}
                className="secondaryButton"
              >
                Back to Roles
              </Link>
            </li>
          </ul>
        </div>

        <div className="row m-0 mb-3">
          {/* Role Details */}
          <fieldset className="mt-3">
            <legend className="w-auto">Role Details</legend>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label confirm_value">Role Name</label>
                <p className="desc_input_text">{roleData.Role}</p>
              </div>
              <div className="col-md-6">
                <label className="form-label confirm_value">Description</label>
                <p className="desc_input_text">{roleData.Description}</p>
              </div>
            </div>
          </fieldset>

          {/* Page Access */}
          <fieldset className="mt-3">
            <legend className="w-auto">Page Access</legend>
            <div className="col-md-12 table-responsive tableMinHeight p-0">
              <table className="table" id="tableListHeader">
                <thead className={`${styles.permission_column}`}>
                  <tr>
                    <th>S.No</th>
                    <th>Menu Name</th>
                    <th>Page Name</th>
                    <th>Access</th>
                  </tr>
                </thead>
                <tbody>
                  {roleData.pageAccess?.map((item, index) => (
                    <tr key={item.id} aria-disabled>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.page}</td>
                      <td>{item.access}</td>
                    </tr>
                  ))}
                  {(!roleData.pageAccess ||
                    roleData.pageAccess.length === 0) && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
}
